export const LoadChatbot = (orgToken: string) => {
    ;(function (w, d, s, r, k, h, m) {
        if (w.performance && w.performance.timing && w.performance.navigation) {
            w[r] =
                w[r] ||
                function () {
                    ;(w[r].q = w[r].q || []).push(arguments)
                }
            h = d.createElement('script')
            h.async = true
            h.setAttribute('src', s + k)
            h.setAttribute('id', 'podium-widget')
            h.setAttribute('organization-api-token', k)
            d.getElementsByTagName('head')[0].appendChild(h)
            ;(m = window.onerror),
                (window.onerror = function (b, c, d, f, g) {
                    m && m(b, c, d, f, g),
                        g || (g = new Error(b as string)),
                        (w[r].q = w[r].q || []).push(['captureException', g])
                })
        }
    })(window, document, 'https://connect.podium.com/widget.js#ORG_TOKEN=', 'pcb', orgToken)
}
